/*======================================================================================================================
  * Bluebell: src/app/state/image-deltas/image-deltas.interfaces.ts
  * Last Edited: 17/07/2025
  * Copyright 2025 Bramble CFD LTD
  * The contents of this file are NOT for redistribution
  * See AUTHORS for list of developers on this project
 =====================================================================================================================*/
import { BasePostproReference, PostproReferenceCase } from '@state/postpro/postpro.interfaces';


export interface ImageDelta extends BasePostproReference {
  uuid: string;
  baseline: PostproReferenceCase;
  variable: string;
  camera: string;
  palette: string;
  delta_range: string;
  metadata: ImageDeltaMetadata;
  type: 'image_delta';
}

export interface ImageDeltaReference extends ImageDelta {
  url: string;
  thumbnailUrl: string;

  plotOverlayReference?: never; //  Always null for type purposes
  licOverlayReference?: never; //  Always null for type purposes
}

export interface ImageDeltaFilters {
  variables: string[];
  baselines: PostproReferenceCase[];
  delta_ranges: string[];
  palettes: string[];
}

export interface ImageDeltaFilterState {
  variables: string[];
  baselines: string[];
  delta_ranges: string[];
  palettes: string[];
}

export const getDefaultImageDeltaFilterState = (filters?: ImageDeltaFilters, existingFilterState?: ImageDeltaFilterState): ImageDeltaFilterState => {
  if (filters) {
    return {
      ...(existingFilterState || getDefaultImageDeltaFilterState()),
      baselines: filters.baselines.map(baseline => baseline.uuid),
      // baselines: filters.baselines.length ? [filters.baselines[0].uuid] : [],
      delta_ranges: filters.delta_ranges,
      // delta_ranges: filters.delta_ranges.length ? [filters.delta_ranges[0]] : [],
      palettes: filters.palettes,
      // palettes: filters.palettes.length ? [filters.palettes[0]] : [],
    };
  } else {
    return {
      variables: [],
      baselines: [],
      delta_ranges: [],
      palettes: [],
    };
  }
};

export interface ImageDeltaMetadata {
  [key: string]: string;
  size: string;
  time: string;
  type: string;
  view: string;
  block: string;
  title: string;
  palette: string;
  baseline: string;
  variable: string;
  compositor: string;
  block_index: string;
  camera_name: string;
  'delta range': string;
  description: string;
  date_created: string;
  'black sensitivity': string;
}
